import { Option, FakePrice, EnumPriceUnit, EnumOptionAccommodationSaleType } from 'src/types';
import ImageWithFallback from 'src/components/ImageWithFallback';
import { AppRoutes } from 'src/lib/routes';
import useCurrentCurrency from 'src/hooks/useCurrentCurrency';
import Money from 'src/components/Money';
import CurrencyProvider from 'src/contexts/CurrencyProvider';
import InitialDataProvider from 'src/contexts/InitialDataProvider';
import { canShowAverageAdvancedGroupPrice } from 'src/helpers';

type Props = {
  option: Option;
};

const OptionCardInner: React.FC<Props> = ({ option }) => {
  const currentCurrency = useCurrentCurrency();
  const shouldShowDisplayAdvancedPrice =
    canShowAverageAdvancedGroupPrice(option) && option.displayAdvancedGroupPrice;
  const minPrice =
    option.accommodationSaleType === EnumOptionAccommodationSaleType.pickRoom &&
    option.priceUnit === EnumPriceUnit.perRoom &&
    option.roomDisplayPrice
      ? option.roomDisplayPrice
      : shouldShowDisplayAdvancedPrice
      ? (option.displayAdvancedGroupPrice as FakePrice)
      : option.minPrice;

  return (
    <a
      href={AppRoutes.experienceRoute({ id: option.slugCode }).toPath()}
      className="md:tw-flex tw-block tw-text-brand-navy tw-my-8 md:tw-my-10"
      style={{ backgroundImage: 'none' }}
    >
      <ImageWithFallback
        record={option.images[0]}
        imgField="webpMdUrl"
        alt=""
        fill
        className="tw-static tw-block md:tw-w-72 tw-h-48 md:tw-h-52 tw-w-full tw-rounded-2xl tw-mb-2.5 md:tw-mb-0 tw-object-cover"
      />
      <div className="md:tw-ml-8">
        <div className="tw-text-sm tw-text-grey tw-pb-1.5 md:tw-pb-2 tw-border-b tw-border-grey-lighter tw-mb-4 tw-leading-none">
          Feeling inspired?
        </div>
        <div className="tw-text-lg tw-font-semibold tw-font-styleSans tw-mb-2">{option.name}</div>
        <div className="tw-mb-2 tw-text-sm">
          <span className="tw-text-grey-light">From</span>{' '}
          <span className="tw-font-semibold">
            <Money amount={minPrice.price || minPrice.masterPrice} toCurrency={currentCurrency} decimalScale={0} hasConversionFee={option.baseCurrency !== currentCurrency} />
          </span>
        </div>
        <a
          href={AppRoutes.experienceRoute({ id: option.slugCode }).toPath()}
          className="btn btn-secondary"
        >
          Book Now
        </a>
      </div>
    </a>
  );
};

const OptionCard: React.FC<Props> = ({ option }) => {
  return (
    <InitialDataProvider>
      <CurrencyProvider>
        <OptionCardInner option={option} />
      </CurrencyProvider>
    </InitialDataProvider>
  );
};

export default OptionCard;
